import {
    CONTAINER_GROUP_LOAD_REQUESTED,
    CONTAINER_GROUP_LOAD_SUCCEEDED,
    CONTAINER_GROUP_LOAD_FAILED,
    EVENT_LABELS_CREATE_REQUESTED,
    EVENT_LABELS_CREATE_SUCCEEDED,
    EVENT_LABELS_CREATE_FAILED,
    CONTAINER_GROUPS_SET,
    CONTAINER_GROUPS_MERGE,
    CONTAINER_GROUP_SET,
    EVENT_LABELS_CANCEL_REQUESTED,
    EVENT_LABELS_CANCEL_SUCCEEDED,
    EVENT_LABELS_CANCEL_FAILED
} from './constants';

import {
    ContainerGroup,
    RequestedContainerGroupAction,
    RequestedPrintLabelsAction,
    RequestedCancelLabelsAction,
    PrintLabelOptions,
    SucceededContainerGroupAction,
    FailedContainerGroupAction,
    SucceededPrintLabelsAction,
    FailedPrintLabelsAction,
    SucceededCancelLabelsAction,
    FailedCancelLabelsAction,
    SetContainerGroupsAction,
    MergeContainerGroupsAction,
    SetContainerGroupAction
} from './types';

export function requestLoadContainerGroup(
    containerGroupId: number
): RequestedContainerGroupAction {
    return {
        type: CONTAINER_GROUP_LOAD_REQUESTED,
        payload: {
            containerGroupId
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadContainerGroup(
    response: Record<string, any>
): SucceededContainerGroupAction {
    return {
        type: CONTAINER_GROUP_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadContainerGroup(
    error: Error
): FailedContainerGroupAction {
    return {
        type: CONTAINER_GROUP_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestEventPrintLabels(
    eventId: number,
    data: PrintLabelOptions
): RequestedPrintLabelsAction {
    return {
        type: EVENT_LABELS_CREATE_REQUESTED,
        payload: {
            eventId,
            data
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededEventPrintLabels(
    response: Record<string, any>
): SucceededPrintLabelsAction {
    return {
        type: EVENT_LABELS_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedEventPrintLabels(error: Error): FailedPrintLabelsAction {
    return {
        type: EVENT_LABELS_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestEventCancelLabels(
    eventId: number
): RequestedCancelLabelsAction {
    return {
        type: EVENT_LABELS_CANCEL_REQUESTED,
        payload: {
            eventId
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededEventCancelLabels(
    response: Record<string, any>
): SucceededCancelLabelsAction {
    return {
        type: EVENT_LABELS_CANCEL_SUCCEEDED,
        payload: response
    };
}

export function failedEventCancelLabels(
    error: Error
): FailedCancelLabelsAction {
    return {
        type: EVENT_LABELS_CANCEL_FAILED,
        payload: error,
        error: true
    };
}

export function setContainerGroups(
    data: ContainerGroup[]
): SetContainerGroupsAction {
    return {
        type: CONTAINER_GROUPS_SET,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function mergeContainerGroups(
    data: ContainerGroup[]
): MergeContainerGroupsAction {
    return {
        type: CONTAINER_GROUPS_MERGE,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function setContainerGroup(
    data: ContainerGroup
): SetContainerGroupAction {
    return {
        type: CONTAINER_GROUP_SET,
        payload: {
            ...data,
            lastRequestedAt: new Date().toISOString()
        }
    };
}
